import React, { useState, useEffect, useRef } from "react";

const Header = () => {
  const [selectedCity, setSelectedCity] = useState("Hyderabad");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const hyderabadAreas = [
    "Banjara Hills",
    "Jubilee Hills",
    "Kukatpally",
    "Madhapur",
    "Ameerpet",
    "Secunderabad",
    "Gachibowli",
    "Dilsukhnagar",
  ];

  const handleSelect = (area) => {
    setSelectedCity(area);
    setShowDropdown(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ Only white text for menu items
  const navLinkStyle = {
    color: "#fff",
    textDecoration: "none",
    fontWeight: "500",
    padding: "8px 15px",
    transition: "color 0.3s ease",
  };

  const navLinkHoverStyle = {
    color: "#e0e0e0",
  };

  return (
    <header
      className="header_sticky"
      style={{
        position: "fixed",
        top: "0",
        left: 0,
        width: "100%",
        zIndex: 1050,
        backgroundColor: "#09bbaf",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Logo */}
          <div className="col-lg-3 col-6" style={{ paddingTop: "0" }}>
            <div id="logo_home">
              <h1 style={{ margin: 0 }}>
                <a
                  href="/"
                  title="Surgeazy"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  Surgeazy
                </a>
              </h1>
            </div>
          </div>

          <nav className="col-lg-9 col-6 d-flex align-items-center justify-content-end">
            <a
              className="cmn-toggle-switch cmn-toggle-switch__htx open_close"
              href="#0"
            >
              <span>Menu mobile</span>
            </a>

            <div className="main-menu">
              <ul style={{ display: "flex", gap: "15px", alignItems: "center" }}>
                <li>
                  <a
                    href="/about"
                    style={navLinkStyle}
                    onMouseEnter={(e) =>
                      Object.assign(e.target.style, navLinkHoverStyle)
                    }
                    onMouseLeave={(e) =>
                      Object.assign(e.target.style, navLinkStyle)
                    }
                  >
                    About Us
                  </a>
                </li>

                <li className="submenu">
                  <a
                    href="#0"
                    className="show-submenu"
                    style={navLinkStyle}
                    onMouseEnter={(e) =>
                      Object.assign(e.target.style, navLinkHoverStyle)
                    }
                    onMouseLeave={(e) =>
                      Object.assign(e.target.style, navLinkStyle)
                    }
                  >
                    Patient Care <i className="icon-down-open-mini"></i>
                  </a>
                  <ul>
                    <li>
                      <a href="/">Home Default</a>
                    </li>
                    <li>
                      <a href="/index-2">Home Version 2</a>
                    </li>
                  </ul>
                </li>

                <li>
                  <a
                    href="/appointment"
                    style={navLinkStyle}
                    onMouseEnter={(e) =>
                      Object.assign(e.target.style, navLinkHoverStyle)
                    }
                    onMouseLeave={(e) =>
                      Object.assign(e.target.style, navLinkStyle)
                    }
                  >
                    Book An Appointment
                  </a>
                </li>

                {/* Location dropdown */}
                <li
                  className="location-dropdown position-relative"
                  ref={dropdownRef}
                  style={{ marginLeft: "15px" }}
                >
                  <button
                    className="btn btn-light dropdown-toggle"
                    type="button"
                    onClick={() => setShowDropdown(!showDropdown)}
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                      padding: "6px 15px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <i className="pe-7s-map-marker"></i> {selectedCity}
                  </button>

                  {showDropdown && (
                    <ul
                      className="dropdown-menu show"
                      style={{
                        position: "absolute",
                        top: "110%",
                        left: 0,
                        zIndex: 3000,
                        minWidth: "200px",
                        backgroundColor: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "10px 0",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                      }}
                    >
                      {hyderabadAreas.map((area, index) => (
                        <li key={index}>
                          <button
                            className="dropdown-item"
                            onClick={() => handleSelect(area)}
                            style={{
                              width: "100%",
                              textAlign: "left",
                              background: "none",
                              border: "none",
                              padding: "8px 20px",
                              cursor: "pointer",
                            }}
                          >
                            {area}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
